module.exports = __webpack_public_path__ + "img/logo.a22e03a6.png";